import { render, staticRenderFns } from "./SwapPopup.vue?vue&type=template&id=d2c82340&scoped=true"
import script from "./SwapPopup.vue?vue&type=script&lang=js"
export * from "./SwapPopup.vue?vue&type=script&lang=js"
import style0 from "./SwapPopup.vue?vue&type=style&index=0&id=d2c82340&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c82340",
  null
  
)

export default component.exports